<template>
  <div class="edit-user">
    <v-dialog v-model="modal" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Edit New User - {{ status }}</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="username" :rules="nameRules" label="Username (*)" required></v-text-field>

                <v-text-field v-model="email" :rules="emailRules" label="E-mail (*)" required></v-text-field>

                <v-select :items="items" v-model="status" label="Status"></v-select>

                <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    label="New Password (optional)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('close')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="isLoading" :disabled="!valid" @click="editUser">Update User</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="$store.state.snackSuccess" :timeout="2000" top color="teal" dark>
        Record Updated!
    </v-snackbar>

  </div>
</template>

<script>
import { db, functions } from '@/plugins/appfirebase'

export default {

    props: [ 'userUID' ],

    created() {
        this.getUser();
    },

  data: () => ({
    
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      isLoading: false,

      username: '',
      email: '',
      password: '',
      status: false,
      items: [
          { text: 'Active', value: false },
          { text: 'Disabled', value: true }
      ],
      modal: true,

  }),

  methods: {

    getUser() {
        this.isLoading = true
        const user = functions.httpsCallable('getThisUser');

        user({ uid: this.userUID }).then( result => {

            this.isLoading = false
            this.username = result.data.displayName
            this.email = result.data.email
            this.status = result.data.disabled
            
        }).catch(err => { console.log(err) })
    },

    editUser() {

        this.isLoading = true
        const updateUser = functions.httpsCallable('updateUser');

        updateUser({ uid: this.userUID, username: this.username, email: this.email, password: this.password, status: this.status })
            .then(result => { 

              if (result.data.errorInfo) { 
                  this.isError = true; 
                  this.isLoading = false;
                  this.errorMessage = result.data.errorInfo.message;
                } else { 
                  
                  if ( this.password != '') {
                    db.collection('users').doc(this.userUID).set({ username: this.username, password: this.password, lock: true })
                    .then(() => { 
                      this.isLoading = false
                      this.$emit('close')
                      location.reload();  
                    })
                  } else {
                    this.isLoading = false
                    this.$emit('close')
                    location.reload();  
                  }
                  
                }
                
             })
    },

  },

}
</script>

<style>

</style>